import { Controller } from "@hotwired/stimulus"
import { Popover } from "bootstrap";

// Connects to data-controller="popover"
export default class extends Controller {
  static values = {
    content: String,
    html: { type: Boolean, default: false },
    trigger: { type: String, default: 'hover' }
  }
  connect() {
    new Popover(this.element, {
      content: this.contentValue,
      html: this.htmlValue,
      trigger: this.triggerValue
    })
  }
}
